// Import the plugins
/* import AwsS3 from '@uppy/aws-s3';
import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import Webcam from '@uppy/webcam'; */
import shortId from 'shortid';

/* import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import '@uppy/webcam/dist/style.css'; */

const Uppy = window.Uppy;

const uppy = new Uppy.Uppy({
  allowMultipleUploadBatches: false,
  restrictions: {
    maxFileSize: 2e9,
    minFileSize: null,
    maxNumberOfFiles: 1,
    minNumberOfFiles: 1
  }
});
uppy.use(Uppy.Dashboard, {
  closeAfterFinish: true,
  proudlyDisplayPoweredByUppy: false
});
uppy.use(Uppy.AwsS3, {
  limit: 1,
  timeout: 30 * 60 * 1000,
  getUploadParameters: file => {
    const fileName = `${new Date().toISOString()}_${shortId()}.${file.extension}`;

    return {
      method: 'PUT',
      url: `https://lyearn-content-submission.s3.amazonaws.com/${fileName}`,
      headers: { 'content-type': file.meta.type }
    };
  }
});
uppy.use(Uppy.Webcam, {
  target: Uppy.Dashboard,
  preferredVideoMimeType: 'video/webm;codecs=vp9,opus',
  preferredImageMimeType: 'image/jpg',
  videoConstraints: { facingMode: 'user' },
  showRecordingLength: true
});

window.uppyInstance = uppy;

/* .on('complete', result => {
    console.log('Upload complete! We’ve uploaded these files:', result.successful);
  }); */

console.log('uppy::', uppy);

export default uppy;
